module.exports = __webpack_public_path__ + "img/hiw-2.4c80bd80.svg";